import { GridColumn } from '../../../../../../generic/grid-table'
import { IMetaDataQ4 } from '../../../../../../modules/API/Reports/models/q4'
import { formatNumber } from '../../Q4/helpers/utils'
import { Q2_FIELD_KEYS } from '../helpers/q2Report'
import { Q2Row } from '../types/row'

const formatPricePerKg = (value: Q2Row[keyof Q2Row]): string =>
  typeof value === 'number' ? value.toFixed(2) : ''

const formatRevenue = (value: Q2Row[keyof Q2Row]): string =>
  typeof value === 'number' ? String(formatNumber(value)) : ''

const formatLocale = (value: Q2Row[keyof Q2Row]): string =>
  typeof value === 'number' ? value.toLocaleString() : ''

/** Dynamic columns follow the report's MetaData (blank labels are hidden), then the fixed metrics. */
export const buildQ2Columns = (meta: IMetaDataQ4): GridColumn<Q2Row>[] => [
  ...Q2_FIELD_KEYS.filter((key) => meta[key]?.trim()).map(
    (key): GridColumn<Q2Row> => ({
      key: `${key}_Label`,
      title: meta[key],
      dataType: 'string',
      sortable: true,
    }),
  ),
  { key: 'AmountPack', title: 'אריזות', dataType: 'number', sortable: true },
  { key: 'AmountPallets', title: 'משטחים', dataType: 'number', sortable: true },
  { key: 'Weight', title: 'משקל', dataType: 'float', sortable: true, formatValue: formatLocale },
  { key: 'PricePerKg', title: 'מחיר', dataType: 'float', sortable: true, formatValue: formatPricePerKg },
  { key: 'Price', title: 'פדיון', dataType: 'float', sortable: true, formatValue: formatRevenue },
]
